// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-button {\n    color: var(--fadedTextColor);\n    padding: 3px;\n}\n.icon-button:hover {\n    color: var(--fadedTextColor);\n}", ""]);
// Exports
module.exports = exports;
